/**
 * Side-effect-free deep entry for the lib's injectable services.
 *
 * Import from `@newgenus/angular-shared-components/services`, NOT the main
 * barrel: the barrel transitively pulls d3 (pure ESM) and `@newgenus/common`
 * (every-moment side effect), both of which break under jest.
 */
export * from './overlay-back-stack.service';
